'use client';

import { IoCameraOutline, IoImagesOutline } from 'react-icons/io5';

import { assetUrl } from '../../../../../utils/asset';
import { Badge } from '../../../../badge';
import { Button } from '../../../../button';
import {
  ActionDialogButtons,
  ActionDialogContent,
  Dialog,
  DialogContent,
} from '../../../../dialog';
import ExampleAsset from './images/2492f598-8ce0-4496-99a2-9b246e362fc0.webp';

import styles from './AnswerSheetGuideDialog.module.scss';

const Example = assetUrl(ExampleAsset);

function prefetchExample() {
  if (typeof Image === 'undefined') {
    return;
  }

  new Image().src = Example;
}

type AnswerSheetGuideDialogProps = {
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
  testId?: string;
};

/** What a readable photo of the sheet looks like, shown before the file picker. */
function AnswerSheetGuideDialog({
  open,
  onConfirm,
  onClose,
  testId,
}: AnswerSheetGuideDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onClose()}>
      <DialogContent data-testid={testId}>
        <ActionDialogContent
          className={styles['content']}
          icon={<IoCameraOutline />}
          title="Sube una foto de la plantilla para leer tus respuestas"
          badge={
            <div className={styles['beta']}>
              <Badge bg="warning">Beta</Badge>
              <span className={styles['beta-note']}>
                Revisa siempre las respuestas
              </span>
            </div>
          }
          media={
            <img
              className={styles['example']}
              src={Example}
              width={527}
              height={464}
              decoding="async"
              fetchPriority="high"
              alt="A la izquierda, la plantilla fotografiada de frente y completa; a la derecha, la misma plantilla inclinada y cortada"
            />
          }
          subtitle="Encuadra la plantilla completa y de frente, sobre una superficie plana, sin sombras ni dobleces y con buena luz"
        >
          <ActionDialogButtons>
            <Button variant="outline-danger" onClick={onClose}>
              Cancelar
            </Button>
            <Button
              variant="primary"
              suffixIcon={<IoImagesOutline />}
              onClick={onConfirm}
            >
              Elegir foto
            </Button>
          </ActionDialogButtons>
        </ActionDialogContent>
      </DialogContent>
    </Dialog>
  );
}

export { AnswerSheetGuideDialog, prefetchExample };
